<template>
  <div class="content-column">
    <header>
      <h3>{{ title }}</h3>
    </header>
    <div class="separator">
      <div class="line"></div>
      <slot name="separator-icon"></slot>
    </div>
    <section>
      <slot name="content"></slot>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.content-column {
  width: 100%;
  display: flex;
  flex-direction: column;

  header {
    h3 {
      margin: 0px;
      @include salesflow-subtitle($font-weight: 500);
      font-size: 1.25rem;
    }
  }

  .separator {
    width: 100%;
    display: flex;
    align-items: center;
    color: $salesflow-primary-hover;

    .line {
      flex: 1;
      height: 1px;
      background: $salesflow-primary-hover;

      &:only-child {
        margin-top: 0.5rem;
      }
    }
  }
}

</style>
